import '../App.css';
import {useState} from 'react';   
import { PageType } from '../Constants';
import { useDispatch } from 'react-redux';
import Header from '../Header';
function Main() {  
  const [data,setdata]=useState(['CODEFORCES','CODECHEF','ATCODER','LEETCODE','HACKEREARTH']); 
  const dispatch=useDispatch();
  const handleNextClick=(page)=>{
        dispatch({type:'SET_PAGE',payload:page});
  }
  return (
    <>
         <Header Pagetype={PageType.MAIN_PAGE} Title={"Pratiyogita Smaran"}/>  
          {
              data.map((platformname,index)=>{
                 let Page=platformname; 
                 return (
                 <div className="div">
                  <p className="name">{platformname}</p>  
                  <button className="button" onClick={()=>handleNextClick(Page)}>Get Info</button>  
                </div> 
                 ) 
                }
              )
         }  
    </>
  );
}

export default Main;
